/** Service fee plans /metering/fee/service-plan (servicePlan.vue) */
export default {
  servicePlanPage: {
    sectionTitle: 'Service fee plans',
    btnAddPlan: 'New plan',
    emptyTable: 'No service fee plans yet',
    emptyNoPermission: 'No permission to view',
    colPlanId: 'Plan ID',
    colPlanName: 'Plan name',
    colPeak: 'Sharp (¥/kWh)',
    colTop: 'Peak (¥/kWh)',
    colFlat: 'Flat (¥/kWh)',
    colValley: 'Valley (¥/kWh)',
    colUpdated: 'Updated',
    colAction: 'Actions',
    btnAdjust: 'Adjust',
    btnLog: 'Log',
    btnBatchBind: 'Batch assign',
    modalTitleEdit: 'Adjust prices',
    modalTitleAdd: 'New plan',
    formPlanName: 'Plan name',
    phPlanName: 'Enter plan name',
    labelPeak: 'Sharp',
    labelTop: 'Peak',
    labelFlat: 'Flat',
    labelValley: 'Valley',
    logLabelPeak: 'Sharp:',
    logLabelTop: 'Peak:',
    logLabelFlat: 'Flat:',
    logLabelValley: 'Valley:',
    unitPerKwh: '¥/kWh',
    warnEditNote: 'Note: saving will update billing for linked meters.',
    labelPhoneBound: 'Phone',
    labelVerifyCode: 'SMS code',
    phVerifyCode: 'Enter code',
    sendCode: 'Send code',
    resendIn: 'Resend in {n}s',
    btnCancel: 'Cancel',
    btnConfirm: 'OK',
    drawerTitle: 'Batch assign meters',
    tabDedicated: 'Dedicated',
    tabShare: 'Shared',
    phSearchMeter: 'Search meter name',
    selectAll: 'Select all',
    tagShareGroup: 'Shared group',
    tagBound: 'Assigned',
    emptyTreeNoMatch: 'No matching meters',
    emptyTreeNoData: 'No meters',
    selectedMeters: '{count} meter(s) selected',
    btnConfirmBind: 'Assign',
    logTitle: 'Price change log',
    emptyLog: 'No records',
    logPlanNameLabel: 'Plan:',
    logPhoneLabel: 'Phone:',
    groupUngrouped: 'Ungrouped',
    msgLoadFail: 'Failed to load data',
    msgNoOperate: 'No permission',
    msgSmsSent: 'Code sent',
    msgSmsFail: 'Failed to send code',
    msgVerifyCode: 'Please enter the SMS code',
    msgNameRequired: 'Please enter a plan name',
    msgPriceIncomplete: 'Please fill in all prices',
    msgPriceZero: 'Price cannot be zero',
    titleTip: 'Notice',
    btnOk: 'OK',
    confirmModify: 'Save changes to this plan?',
    confirmAdd: 'Create this plan?',
    msgOpOk: 'Saved',
    msgOpFail: 'Operation failed',
    confirmBindMeters: 'Assign {count} meter(s) to this plan?',
    msgBindOk: 'Assigned',
    msgBindFail: 'Assign failed',
    msgSelectMeters: 'Select at least one meter',
    msgSelectNewMeters: 'Select meters that are not already assigned',
    msgMeterListFail: 'Failed to load meters',
    msgLogFail: 'Failed to load log'
  }
}
